import React from 'react'
import { Route } from 'react-router-dom'

import TopicContainer from 'pages/Admin/Topics/container'

const AdminTopic = () => (
  <React.Fragment>
    <Route path="/:workspaceToken/settings/topics/" component={TopicContainer} />
  </React.Fragment>
)

export default AdminTopic



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Topics/index.js